// extracted by mini-css-extract-plugin
export default {"containerInfo":"Info_containerInfo__CKZNN","headerInfo":"Info_headerInfo__o-Dq+","bodyInfo":"Info_bodyInfo__rjAmw"};